export const lightTheme = {
    // Surfaces for the CRM module (cards, drawers, dialogs, menus).
    crm: { mode: 'light', page: 'transparent', surface: '#ffffff', input: '#ffffff', text: 'inherit' },
    colors: {
        body: '#E2E2E2',
        primary: '#263BA6',
        secondary: '#77787C',
        danger: '#F6392D',
        white: '#FFFFFF',
        cyan: '#74E1CF',
        gray: '#818A8E',
        black: '#000000',
        inputbackground: '#EDEFF8',
        hover: '#EDEFF8',
    },
    button: {
        shadow: 'rgba(115, 205, 190, 0.25)',
        border: 'rgba(255, 255, 255, 0.18)',
        background: '#74E1CF',
        backgroundHover: '#81FAE6',
        color: '#000000',
    },
    sidebar: {
        activeText: '#FFFFFF',
        text: '#818A8E',
    },
    home: {
        background: 'rgba(37, 39, 40, 0.6)',
        border: 'rgba(139, 139, 139, 0.4)',
        popular: {
            color: '#818A8E',
        },
        cyan: '#74E1CF',
    },
}

export const darkTheme = {
    crm: { mode: 'dark', page: '#111827', surface: '#1f2937', input: '#111827', text: '#e5e7eb' },
    colors: {
        body: '#E2E2E2',
        primary: '#73CDBE',
        danger: '#F6392D',
        white: '#FFFFFF',
        cyan: '#74E1CF',
        gray: '#818A8E',
        black: '#000000',
    },
};